import { baseFetch } from "./base";
import {
  MmkItem,
  QuizItemsResponse,
  type PersonalCardSavePayload,
  type PersonalCardsResponse,
  type QuizCompletePayload,
} from "@/types/mmk";

export interface MmkItemsResponse {
  items: MmkItem[];
  total_count: number;
}

export const getMmkItems = async (): Promise<MmkItemsResponse> => {
  const response = await baseFetch.get<MmkItemsResponse>("/mkk/items");
  return response.data;
};

export type MmkAction =
  | "mark_as_known"
  | "pin"
  | "review_later"
  | "flip"
  | "open_mmm"
  | "quiz_wrong";

export interface MmkActionResponse {
  status: string;
  item?: Partial<MmkItem> & { id: string };
}

export const postMmkItemAction = async (
  id: string,
  action: MmkAction,
): Promise<MmkActionResponse> => {
  const response = await baseFetch.post<MmkActionResponse>(
    `/mkk/items/${id}/action`,
    { action },
  );
  return response.data;
};

export const getQuizItems = async (
  count: number = 5,
): Promise<QuizItemsResponse> => {
  const response = await baseFetch.get<QuizItemsResponse>("/mkk/quiz/items", {
    params: { count },
  });
  return response.data;
};

export const postQuizComplete = async (
  payload: QuizCompletePayload,
): Promise<{ status: string }> => {
  const response = await baseFetch.post<{ status: string }>(
    "/mkk/quiz/complete",
    payload,
  );
  return response.data;
};

export const getPersonalCards = async (): Promise<PersonalCardsResponse> => {
  const response =
    await baseFetch.get<PersonalCardsResponse>("/mkk/personal_cards");
  return response.data;
};

export const savePersonalCards = async (
  cards: PersonalCardSavePayload[],
): Promise<{ status: string }> => {
  const response = await baseFetch.post<{ status: string }>(
    "/mkk/personal_cards",
    { personal_cards: cards },
  );
  return response.data;
};

// export const postMmkAnalytics = async (
//   event: string,
//   payload: Record<string, unknown> = {}
// ): Promise<void> => {
//   try {
//     await baseFetch.post("/mkk/analytics", { event, payload });
//   } catch {
//     // Analytics failures should not break the app
//   }
// };
